import React from 'react';
import cn from 'bem-cn';

import './MyProfileFavorites.scss';

const b = cn('my-profile-favorites');

export const MyProfileFavorites: React.FC = () => {
    return <div className={b()}>{/* Избранное */}</div>;
};
